<div class="d-flex align-items-center g-0 mb-5">
    <div class="text-s text-default text-line-1 text-uppercase font-extra-bold me-1" translate>v3-preview-weekly-goal-header</div>
    <div class="inline">
        <div
            [ngbTooltip]="'v3-preview-weekly-goal-header-tooltip' | translate: { mins: statistics.goal.declarated.seconds / 60 }"
            placement="left"
            container="body"
            class="icon icon-l icon-default"
            inlineSVG="assets/icons.svg#help-2"
        ></div>
    </div>
</div>

<div class="mb-4">
    <app-goal-line-goal [withTitle]="false"></app-goal-line-goal>
</div>

<div
    class="text-default text-xs text-line-2 mb-5 text-center"
    [innerHTML]="
        'v3-app-goal-box-statistics-next-x-more-mins-old'
            | translate
                : {
                      x:
                          (statistics.goal.declarated.seconds - statistics.goal.current.seconds < 0
                              ? 0
                              : statistics.goal.declarated.seconds - statistics.goal.current.seconds
                          )
                          | time: { type: 'none' }
                          | strong,
                  }
    "
></div>

<div class="hline hline-info mb-5 w-75 mx-auto"></div>

<div [ngbTooltip]="'v3-panel-current-streak-tooltip' | translate" container="body" class="bg-light text-center rounded py-2 mb-5 w-50 mx-auto">
    <div class="font-bold text-line-1 mb-2">{{ statistics.streak.current }}</div>
    <div class="text-xxs font-semi-bold" translate>v3-preview-weekly-goal-current-streak</div>
</div>

<div class="hline hline-info mb-5 w-75 mx-auto"></div>

<div [ngbTooltip]="'v3-panel-best-streak-tooltip' | translate" container="body" class="bg-light text-center rounded py-2 w-50 mx-auto">
    <div class="font-bold text-line-1 mb-2">{{ statistics.streak.best }}</div>
    <div class="text-xxs font-semi-bold" translate>v3-preview-weekly-goal-best-streak</div>
</div>
